import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { successToast, errorToast } from "../../../toastAlerts/ToastAlerts";
import { AdminPrimaryContext } from "../../../adminContext/AdminContext";
import PassedPackagesItem from "./PassedPackagesItem";
import axiosAdmin from "../../../../../api/apiAdmin";
import PaginatedItems from "../../../Pagination/Pagination";
import { useTranslation } from "react-i18next";

//icons
import { FaRegHandPointRight } from "react-icons//fa";
import { BiLoaderAlt } from "react-icons/bi";
import {
  CheckBox,
  SelectInputValueId,
} from "../../../inputComponents/inputcomp";
import { BsX } from "react-icons/bs";
import { apiError } from "../../../../../api/apiError";
import AdminDownloadLink from "../../../AdminDownloadLink";

const PassedPackages = () => {
  const { t } = useTranslation();
  //current filial
  const [currentPlaceId, setCurrentPlaceId] = useState(0);
  //filials data
  const { foreignAdresses } = useContext(AdminPrimaryContext);
  //package data
  const [packageData, setPackageData] = useState([]);
  //package dataErr
  const [packageDataErr, setPackageDataErr] = useState([]);
  //affect data change depended on delete and add responses
  const [difResponses, setDifResponses] = useState(null);
  //search value and transportation
  const [search, setSearch] = useState({
    key: "",
  });
  //current page
  const [currentPage, setCurrentPage] = useState(0);
  //total count
  const [total, setTotal] = useState(0);
  //shipment code for express
  const [shipmentCode, setShipmentCode] = useState("");
  //is loading state
  const [isLoading, setIsLoading] = useState(false);
  //transportation and secured parcels
  const [transportation, setTransportation] = useState({
    repack: "",
  });
  //shipments
  const [shipments, setShipments] = useState([]);

  //handle change search value
  const handleSearchvalue = (e, inputName) => {
    setSearch((prev) => ({ ...prev, [inputName]: e.target.value }));
  };

  //current filial handler
  const handleCurrentPlaceId = (value) => {
    setCurrentPlaceId(value);
  };

  //handle transportation value
  const handleSearchTransport = (value, inputName) => {
    setTransportation((prev) => ({ ...prev, [inputName]: value }));
  };

  //handle delete package
  const handleDeletePackage = async (id) => {
    try {
      const res = await axiosAdmin.delete(`/packs/${id}`);
      if (res) {
        setDifResponses(res);
        successToast(t("admin_package_deleted_success"));
      }
    } catch (err) {
      setPackageDataErr(err);
      errorToast(apiError(err, t("admin_error_try_again")));
    }
  };

  //handle sent pack back
  const handleSendBack = (id) => {
    axiosAdmin
      .get(`/packs/back/${id}`)
      .then((res) => {
        successToast(t("admin_packages_returned_to_previous_section"));
        setDifResponses(res);
      })
      .catch((err) => {
        errorToast(err?.response?.data?.error || t("admin_error_try_again"));
      });
  };

  //data fetching
  const handleParcelInfo = () => {
    setIsLoading(true);
    axiosAdmin
      .get(
        `/packs?status=${4}&abroad_office_id=${currentPlaceId}&page=${
          currentPage + 1
        }&per_page=${20}` +
          `&searchValue=${search.key}` +
          `&repack=${
            transportation.repack === "false" ? "" : transportation.repack
          }`
      )
      .then(({ data }) => {
        setPackageData(data.data);
        setTotal(data.meta.total);
        setIsLoading(false);
      })
      .catch((err) => {
        setPackageDataErr(err);
      });
  };

  //on barcode scanner using
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleParcelInfo();
    }
  };

  //package data fetching
  useEffect(() => {
    setCurrentPage(0);
  }, [search]);

  //package data fetching
  useEffect(() => {
    handleParcelInfo();
  }, [currentPlaceId, difResponses, currentPage, transportation]);

  useEffect(() => {
    axiosAdmin
      .get(`/shipments?per_page=500`)
      .then(({ data }) => {
        setShipments((prev) => [
          ...data.data.map((item) => {
            return {
              value: item.code,
              name: item.code,
            };
          }),
        ]);
      })
      .catch((err) => {});
  }, []);

  return (
    <div
      className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 
            min-h-screen p-10 sm:p-5 pb-24 sm:pb-24"
    >
      <div className="w-full overflow-auto scrollbar mb-5">
        <div className="flex gap-1 w-full md:w-[1000px] p-2">
          {foreignAdresses.map((item) => {
            return (
              <div
                key={item.id}
                className={`w-full flex items-center p-3 rounded-lg gap-5 cursor-pointer
                    shadow-[rgba(50,50,93,0.25)_0px_2px_5px_-1px,rgba(0,0,0,0.3)_0px_1px_3px_-1px] 
                    ${
                      currentPlaceId === item.id
                        ? "border border-green-500 bg-green-100"
                        : "bg-white dark:bg-slate-700 "
                    }`}
              >
                <div className="w-full flex flex-col gap-2">
                  <p className="text-[14px] text-[#8e95a8]">
                    {`${item.country} address`}
                  </p>
                  <div className="flex gap-1">
                    <div
                      onClick={() => {
                        handleCurrentPlaceId(item.id);
                      }}
                      className="w-full rounded-lg bg-green-400
                 flex items-center justify-center gap-1 p-1 py-3 text-white"
                    >
                      <FaRegHandPointRight />
                      <p>{t("admin_choose")}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <h2 className="text-slate-400 text-2xl">{t("admin_receivable_packages")}</h2>
      <div className="w-full">
        <div className="w-full mt-2 flex gap-1 sm:flex-col">
          <div
            className="bg-white  pv-2 flex items-center hover:outline-slate-400 hover:outline-2
            hover:outline gap-x-1  px-3.5 py-1 rounded-lg dark:bg-slate-800 border-gray-300
            border dark:border-slate-600 w-9/12 sm:w-full"
          >
            <input
              type="search"
              placeholder={t("admin_search")}
              onChange={(e) => {
                handleSearchvalue(e, "key");
              }}
              className="w-full h-8 pl-1.5 focus:outline-none dark:text-white
                                dark:bg-slate-800 border-0"
              onKeyDown={handleKeyPress}
            />
          </div>

          <div className="flex items-center w-full">
            <SelectInputValueId
              options={shipments}
              inputName={"shipmentId"}
              inputSetter={(flight_num, _) => {
                setShipmentCode(flight_num);
              }}
              value={shipmentCode}
              defaultText={t("admin_flight_number_for_excel")}
            />
            <BsX
              className="text-red-500 text-2xl shrink-0 cursor-pointer"
              onClick={() => {
                setShipmentCode("");
              }}
            />
          </div>
          <AdminDownloadLink
            filename="packs.xlsx"
            href={
              `${
                process.env.REACT_APP_API_URL
              }/api/exportPacks?status=${4}&abroad_office_id=${currentPlaceId}` +
              `&shipment_code=${shipmentCode}` +
              `&repack=${
                transportation.repack === "false" ? "" : transportation.repack
              }`
            }
            className="w-3/12 rounded-lg bg-green-400 sm:w-full
                 flex items-center justify-center p-1 py-3 text-white"
          >
            EXPORT CSV
          </AdminDownloadLink>
        </div>
        <div className="mt-2">
          <CheckBox
            name={t("admin_repacked_packages")}
            inputName={"repack"}
            handleCarData={handleSearchTransport}
          />
        </div>
        <div className="w-full flex gap-3 flex-wrap mt-5">
          <PaginatedItems pageNumberSetter={setCurrentPage} dataLength={total}>
            {isLoading ? (
              <div className="mt-5 w-full flex items-center justify-center min-h-[200px]">
                <BiLoaderAlt className="w-20 h-20 animate-spin text-green-500" />
              </div>
            ) : isLoading === false && packageData.length === 0 ? (
              <div className="mt-5 w-full flex items-center justify-center min-h-[200px]">
                <p className="text-slate-600 text-sm">{t("admin_no_data_found")}</p>
              </div>
            ) : (
              <div className="w-full flex flex-col gap-2">
                {packageData.map((item) => {
                  return (
                    <PassedPackagesItem
                      key={item.id}
                      data={item}
                      handleDeletePackage={handleDeletePackage}
                      handleSendBack={handleSendBack}
                      setDifResponses={setDifResponses}
                    />
                  );
                })}
              </div>
            )}
          </PaginatedItems>
        </div>
      </div>
    </div>
  );
};

export default PassedPackages;
